import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Briefcase, CheckCircle, Users } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberProjects() {
  const { user } = useAuth();
  const [progetti, setProgetti] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { axios.get(`${API}/progetti`).then(r => setProgetti(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  const partecipa = async (id) => {
    try {
      await axios.post(`${API}/progetti/${id}/partecipa`, {});
      toast.success("Partecipazione registrata!");
      setProgetti(prev => prev.map(p => p.id === id ? { ...p, membri: [...(p.membri || []), user.id] } : p));
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
  };

  const sc = (s) => ({ attivo: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20", in_corso: "bg-[#00A0D1]/10 text-[#00A0D1] border-[#00A0D1]/20", completato: "bg-white/5 text-white/40 border-white/10" }[s] || "");
  if (loading) return <div className="text-center py-12 text-white/30">Caricamento progetti...</div>;

  return (
    <div data-testid="member-progetti" className="space-y-3">
      <p className="text-sm text-white/40 mb-4">{progetti.length} progetti disponibili</p>
      {progetti.map(p => {
        const joined = p.membri?.includes(user?.id);
        return (
          <div key={p.id} className="glass-card rounded-lg border border-white/8 p-5 hover:border-[#00A0D1]/20 transition-all" data-testid={`member-project-${p.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <Briefcase className="w-5 h-5 text-[#00A0D1] flex-shrink-0" />
                  <h3 className="text-base font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>{p.titolo}</h3>
                  <Badge className={`text-[10px] border ${sc(p.stato)}`}>{p.stato}</Badge>
                </div>
                <p className="text-sm text-white/40 ml-8 mb-3">{p.descrizione}</p>
                <div className="flex items-center gap-4 ml-8">
                  <div className="flex items-center gap-1.5 text-xs text-white/25"><Users className="w-3.5 h-3.5" /> {p.membri?.length || 0}</div>
                  <p className="text-xs text-white/20">di {p.created_by_name}</p>
                </div>
              </div>
              <div className="flex-shrink-0">
                {joined ? (
                  <div className="flex items-center gap-1.5 text-emerald-400 text-sm font-medium" data-testid={`project-joined-${p.id}`}><CheckCircle className="w-4 h-4" /> Membro</div>
                ) : (p.stato === "attivo" || p.stato === "in_corso") ? (
                  <Button data-testid={`project-participate-button-${p.id}`} onClick={() => partecipa(p.id)} className="bg-[#00A0D1] text-white hover:bg-[#00A0D1]/90 text-sm">Partecipa</Button>
                ) : (
                  <Badge className="bg-white/5 text-white/30 border-white/10 text-xs border">Completato</Badge>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {progetti.length === 0 && <div className="text-center py-12 text-white/30">Nessun progetto disponibile</div>}
    </div>
  );
}
